import { render, staticRenderFns } from "./NpaReport.vue?vue&type=template&id=58074481&scoped=true"
import script from "./NpaReport.vue?vue&type=script&lang=js"
export * from "./NpaReport.vue?vue&type=script&lang=js"
import style0 from "./NpaReport.vue?vue&type=style&index=0&id=58074481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58074481",
  null
  
)

export default component.exports